<template>
	<div
		class="section-title"
		:class="[
			`-${type}`,
			{
				'-spacing': verticalSpacing,
				'-align-center': alignCenter,
			}
		]"
	>
		<a
			v-if="moreLinkActive && moreLink"
			class="section-title__link-mobile"
			:href="moreLink"
		/>
		<component
			:is="computedLevel"
			class="section-title__text"
		>
			{{ title }} <slot name="inner" />
			<Icon
				v-if="moreLinkActive && moreLink"
				class="section-title__link-mobile-icon"
				icon-name="right-arrow"
				size="sm"
			/>
		</component>
		<slot name="outer" />
		<a
			v-if="moreLinkActive && moreLink"
			class="section-title__link"
			:href="moreLink"
		>
			<span class="section-title__link-text">{{ moreText ? moreText : $I18n.trans('commons.show_more') }}</span>
		</a>
	</div>
</template>

<script>
import Icon from '@shared/components/Icon';
const types = ['main', 'main-lg', 'lg', 'md', 'sm'];

export default {
	name:       'SectionTitle',
	components: { Icon },
	props:      {
		type: {
			type:      String,
			default:   'lg',
			validator: (type) => types.includes(type),
		},
		title: {
			type:     String,
			required: true,
		},
		verticalSpacing: {
			type:    Boolean,
			default: true,
		},
		moreLink: {
			type:    String,
			default: null,
		},
		moreText: {
			type:    String,
			default: null,
		},
		moreLinkActive: {
			type:    Boolean,
			default: true,
		},
		alignCenter: {
			type:    Boolean,
			default: false,
		},
	},
	computed: {
		computedLevel() {
			switch (this.type) {
			case 'main':
				return 'h1';
			case 'main-lg':
				return 'h1';
			case 'lg':
				return 'h2';
			default:
				return 'h3';
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@sass/variables';

/* stylelint-disable */
.section-title {
	position: relative;
	display: flex;
	justify-content: space-between;
	align-items: baseline;

	&.-spacing {
		&.-main {
			margin-bottom: var(--t-section-title-main__margin-bottom);
		}

		&.-main-lg {
			margin-bottom: var(--t-section-title-main-lg__margin-bottom);
		}

		&.-lg {
			margin-bottom: var(--t-section-title-lg__margin-bottom);
		}

		&.-md {
			margin-bottom: var(--t-section-title-md__margin-bottom);
		}

		&.-sm {
			margin-bottom: var(--t-section-title-sm__margin-bottom);
		}

		&.-lg + &.-sm {
			margin-top: -#{$sp3};

			@include size(md-up) {
				margin-top: -#{$sp4};
			}
		}
	}
}

.section-title__text {
	color: var(--color-white);

	.section-title.-main & {
		font-family: var(--t-section-title-main__font-family);
		font-weight: var(--t-section-title-main__font-weight);
		font-size: var(--t-section-title-main__font-size);
		letter-spacing: var(--t-section-title-main__letter-spacing);
		line-height: var(--t-section-title-main__line-height);
	}

	.section-title.-main-lg & {
		font-family: var(--t-section-title-main-lg__font-family);
		font-weight: var(--t-section-title-main-lg__font-weight);
		font-size: var(--t-section-title-main-lg__font-size);
		letter-spacing: var(--t-section-title-main-lg__letter-spacing);
		line-height: var(--t-section-title-main-lg__line-height);
	}

	.section-title.-lg & {
		font-family: var(--t-section-title-lg__font-family);
		font-weight: var(--t-section-title-lg__font-weight);
		font-size: var(--t-section-title-lg__font-size);
		letter-spacing: var(--t-section-title-lg__letter-spacing);
		line-height: var(--t-section-title-lg__line-height);
		text-transform: var(--t-section-title-lg__text-transform);
	}

	.section-title.-md & {
		font-family: var(--t-section-title-md__font-family);
		font-weight: var(--t-section-title-md__font-weight);
		font-size: var(--t-section-title-md__font-size);
		letter-spacing: var(--t-section-title-md__letter-spacing);
		line-height: var(--t-section-title-md__line-height);
		color: var(--color-white);

		body.-t-light & {
			color: var(--color-black);
		}
	}

	.section-title.-sm & {
		font-family: var(--t-section-title-sm__font-family);
		font-weight: var(--t-section-title-sm__font-weight);
		font-size: var(--t-section-title-sm__font-size);
		letter-spacing: var(--t-section-title-sm__letter-spacing);
		line-height: var(--t-section-title-sm__line-height);
		color: var(--color-grey-400);
	}

	.section-title.-align-center & {
		text-align: center;
		width: 100%;
	}

	body.-t-light & {
		color: var(--color-black);
	}
}

.section-title__link {
	color: var(--color-hype-yellow);
	white-space: nowrap;

	&:hover,
	&:focus {
		color: var(--color-hype-yellow--active);
	}

	body.-t-krone & ,
	body.-t-sportpass & {
		color: var(--color-soft-white);

		&:hover,
		&:focus {
			color: var(--color-grey-200);
		}
	}

	@include size(md-down) {
		display: none;
	}
}

.section-title__link-text {
	@include size(md-down) {
		display: none;
	}
}

.section-title__link-mobile-icon {
	transform: translateY(10%);

	@include size(lg-up) {
		display: none;
	}
}

.section-title__link-mobile {
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;

	@include size(lg-up) {
		display: none;
	}
}

</style>
